import {
  EXERCISE_KEY,
  getByIdWorkoutExerciseSelector,
  SET_DATA_KEY,
  WORKOUT_EXERCISE_KEY
} from '@gymaholic/packages'
import { View } from 'components/View'
import getIdReduxUtil from 'modules/redux/utils/get-id'
import getValueReduxUtil from 'modules/redux/utils/get-value'
import { getByIdExerciseSelector } from 'modules/workout/redux/selectors'
import React from 'react'
import useSelector from 'modules/component/utils/hooks/useSelector.js'
import SetRowMenuIcon from 'pages/Creator/SetRow/components/MenuIcon/index.js'
import canEditByIdWorkoutSelector from 'modules/workout/redux/selectors/can-edit-by-id/index.js'
import getCurrentIdWorkoutSelect from '@gymaholic/packages/src/modules/workout/redux/selectors/get-current-id'
import pushRouterAction from 'modules/router/actions/push/index.js'
import interpolateRouteUtil from 'modules/routes/utils/interpolate/index.js'
import { ROUTE_PATH } from 'modules/routes/constants/index.cjs'
import useDispatch from 'modules/component/utils/hooks/useDispatch.js'
import getSlugExerciseNameUtil from 'modules/exercise/utils/get-slug/index.js'
import SetRowImage from 'pages/Creator/SetRow/components/SetRowImage/index.js'
import SetRowButtons from 'pages/Creator/SetRow/components/SetRowButtons/index.js'
import SetRowTitle from 'pages/Creator/SetRow/components/SetRowTitle/index.js'
import SetRowNotes from 'pages/Creator/SetRow/components/SetRowNotes/index.js'

/**
 * @param props
 * @param props.workoutExerciseId
 * @param props.workoutExerciseObj
 * @param props.setData
 * @param props.isSelected
 * @param props.handleClickSetValue
 * @param props.handleClickSetType
 * @param props.handleClickWeight
 * @param props.hideImage
 * @param props.setIndex
 * @param props.isWorkoutScreen
 * @param props.workoutSectionId
 * @returns {Element}
 * @constructor
 */
export default function SetRow (props) {
  const {
    workoutExerciseId,
    workoutExerciseObj,
    setData,
    isSelected,
    handleClickSetValue,
    handleClickSetType,
    handleClickWeight,
    hideImage,
    setIndex,
    isWorkoutScreen,
    workoutSectionId
  } = props

  const workoutId = useSelector(getCurrentIdWorkoutSelect)
  const canEdit = useSelector(canEditByIdWorkoutSelector(workoutId))
  const dispatch = useDispatch()

  if (!setData) {
    return <View />
  }

  const workoutExercise = workoutExerciseId
    ? useSelector(getByIdWorkoutExerciseSelector(workoutExerciseId))
    : workoutExerciseObj

  const exerciseId = getIdReduxUtil(
    getValueReduxUtil(workoutExercise, WORKOUT_EXERCISE_KEY.EXERCISE)
  )
  const exercise = useSelector(
    getByIdExerciseSelector(exerciseId)
  )
  const notes = (
    getValueReduxUtil(workoutExercise, WORKOUT_EXERCISE_KEY.NOTES) ||
    setData[SET_DATA_KEY.NOTES]
  )
  const isRest = !!setData.rest

  let bgc
  if (isSelected && isWorkoutScreen) {
    // bgc = '#F6F6F6'
    bgc = '#FFFFFF'
  } else if (isSelected) {
    bgc = '#F6F6F6'
  } else {
    bgc = '#FFFFFF'
  }

  const handleClick = () => {
    const exerciseName = getValueReduxUtil(exercise, EXERCISE_KEY.NAME)
    dispatch(
      pushRouterAction({
        pathname: interpolateRouteUtil(
          ROUTE_PATH.VIEW_EXERCISE_SLUG,
          {
            id: getIdReduxUtil(exercise),
            slug: getSlugExerciseNameUtil(exerciseName)
          }
        )
      })
    )
  }

  return (
    <View
      row
      ac
      pb='1.125em'
      pt={hideImage ? 0 : '1.5em'}
      onClick={handleClick}
      style={{
        cursor: 'pointer'
      }}
    >
      {
        !hideImage && (
          <View>
            <SetRowImage
              exerciseId={exerciseId}
              isRest={isRest}
            />
          </View>
        )
      }

      <View
        pl='15px'
        h='100px'
        bgc={bgc}
        w='100%'
        jc
        style={{
          position: 'relative',
          borderTopRightRadius: '6px',
          borderBottomRightRadius: '6px'
        }}
      >
        <View
          row
        >
          {
            !!canEdit &&
            isWorkoutScreen && (
              <SetRowMenuIcon
                workoutExerciseId={workoutExerciseId}
                workoutSectionId={workoutSectionId}
                setIndex={setIndex}
              />
            )
          }
        </View>

        <SetRowTitle
          exercise={exercise}
          isRest={isRest}
          setIndex={setIndex}
        />

        <SetRowNotes
          notes={notes}
          isRest={isRest}
        />

        <SetRowButtons
          setData={setData}
          isRest={isRest}
          isSelected={isSelected}
          handleClickSetValue={handleClickSetValue}
          handleClickSetType={handleClickSetType}
          handleClickWeight={handleClickWeight}
        />
      </View>
    </View>
  )
}
